import React from "react";
import styled from "styled-components";

// 색상 (aisearch.js 또는 테마에서 가져오는 것이 좋지만, 여기서는 직접 정의)
const goldAccent = "#a98e5d";
const darkGray = "#222222";
const stepTextColor = "#333"; // 원 안의 텍스트 색상

// 전체 섹션 컨테이너
const SectionContainer = styled.div`
  padding: 30px 10px; // 섹션 상하좌우 여백
  margin-bottom: 30px; // 다음 섹션과의 간격
  background-color: #f9f9f9; // 페이지 배경과 동일하게 또는 약간 다르게 설정 가능
`;

// 스텝들을 감싸는 컨테이너 (Flexbox 사용)
const StepsWrapper = styled.div`
  display: flex;
  justify-content: space-around; // 스텝 사이 간격 균등 배분
  align-items: flex-start; // 상단 정렬
  flex-wrap: wrap; // 화면 작을 시 줄바꿈
  gap: 20px; // 줄바꿈 시 간격
`;

// 개별 스텝 원 컨테이너
const StepCircle = styled.div`
  flex: 1; // 가능한 공간 동일하게 차지
  min-width: 150px; // 최소 너비 설정 (내용 깨짐 방지)
  max-width: 180px; // 최대 너비 설정 (너무 커지지 않게)
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

// 스텝 번호 원 스타일
const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${goldAccent}; // 골드 배경
  color: ${darkGray}; // 어두운 텍스트
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 15px; // 텍스트와의 간격
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

// 스텝 설명 텍스트
const StepText = styled.p`
  font-size: 0.95em;
  color: ${stepTextColor};
  line-height: 1.5;
`;

// 액션 스텝 데이터
const steps = [
  { number: 1, text: "면세점 상품 최저가를 검색해보세요" },
  {
    number: 2,
    text: "없는 상품 혹은 알림을 받아보고 싶은 상품은 키워드를 등록해주세요",
  },
  { number: 3, text: "AI 가 5분 내로 알림을 드립니다" },
];

export const ActionStepsSection = () => {
  return (
    <SectionContainer>
      <StepsWrapper>
        {steps.map((step) => (
          <StepCircle key={step.number}>
            <StepNumber>{step.number}</StepNumber>
            <StepText>{step.text}</StepText>
          </StepCircle>
        ))}
      </StepsWrapper>
    </SectionContainer>
  );
};
